var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_301_32594",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.001 8.51617C16.9825 13.2175 13.1609 17.0316 8.46396 17.0008C3.64378 16.9638 -0.0668885 13.0265 0.000914457 8.36213C0.0748813 3.75319 3.8965 -0.0608805 8.64888 0.000736254C13.2225 0.062353 17.0195 3.89491 17.001 8.51617ZM1.36314 8.4792C1.36314 12.4473 4.56221 15.6575 8.50711 15.6514C12.4212 15.6452 15.6326 12.4412 15.6449 8.52233C15.6634 4.60351 12.4458 1.37479 8.51327 1.36863C4.55604 1.36247 1.36314 4.53573 1.36314 8.4792Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57017 8.53308C6.73805 7.70742 5.97372 6.93721 5.19707 6.17316C4.98133 5.9575 4.87655 5.7172 4.96284 5.42144C5.10461 4.91002 5.721 4.77446 6.12166 5.17497C6.83051 5.87124 7.53319 6.57983 8.23588 7.28842C8.31601 7.36853 8.37765 7.46095 8.47627 7.59035C8.90774 7.14671 9.30223 6.7462 9.69672 6.34569C10.0419 5.99447 10.3932 5.64942 10.7446 5.2982C11.1576 4.88537 11.5582 4.83608 11.8664 5.15032C12.1746 5.46457 12.1191 5.85892 11.7 6.27175C11.0528 6.91872 10.4117 7.5657 9.75836 8.20651C9.6659 8.29894 9.54262 8.36056 9.38236 8.47147C9.7337 8.8042 10.0172 9.06299 10.2823 9.32794C10.7507 9.79006 11.213 10.2584 11.6753 10.7205C12.1191 11.1641 12.1808 11.54 11.8664 11.8604C11.5459 12.187 11.1637 12.1315 10.7261 11.6879C9.99259 10.9546 9.26525 10.2214 8.43312 9.38339C8.35299 9.51895 8.30368 9.65451 8.21122 9.74693C7.52703 10.4432 6.83667 11.1333 6.14631 11.8173C5.88126 12.0822 5.59156 12.1315 5.30802 11.9898C5.04297 11.8542 4.88271 11.5708 4.95668 11.275C4.99982 11.1087 5.11077 10.9423 5.23405 10.8129C5.90592 10.1228 6.59628 9.44501 7.28047 8.76106C7.35444 8.68096 7.45306 8.61935 7.57017 8.53308Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_301_32594)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1,
    width: 20,
    height: 20,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelWhite);
export default __webpack_public_path__ + "static/media/cancel_white.72cc78abd47a50df4614fdba14d91ea7.svg";
export { ForwardRef as ReactComponent };